import { Component, Input, OnInit } from '@angular/core';
import { ModalRef } from '@shared/ui';

@Component({
  template: `
    <!-- TODO: Port modal to webapp stack  -->
  `,
})
export class CreateMilestoneUpgradeModalComponent implements OnInit {
  @Input() bidId: number;
  @Input() bidderId: number;
  @Input() projectId: number;

  constructor(
    private modalRef: ModalRef<CreateMilestoneUpgradeModalComponent>,
  ) {}

  ngOnInit() {
    // FIXME: port this modal to the webapp stack
    (<any>window).messagingWebappCompatModals.CreateMilestoneUpgradeModal.open({
      bidId: this.bidId,
      bidderId: this.bidderId,
      projectId: this.projectId,
    });
  }

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/projects/create-milestone-upgrade-modal/create-milestone-upgrade-modal.component.ts